import { listValOrUndef, nbVal, nbValOrUndef, strValOrUndef } from "@paroi/data-formatters-lib";
import { type GeneratedReference, formatToGeneratedReference } from "./reference.formatter";

export interface Settings {
  id: number;
  defaultReferenceId?: number;
  defaultReference?: GeneratedReference;
  defaultTableId?: number;
  references?: SettingsReference;
}

type SettingsReference = Map<
  string,
  {
    kpis?: Kpi[];
    referenceId?: number;
  }
>;

interface Kpi {
  name?: string;
  property?: string;
  value?: string;
}

export function formatToSettings(data: unknown): Settings {
  if (
    typeof data !== "object" ||
    data === null ||
    Array.isArray(data) ||
    !("id" in data)
  ) {
    // TODO: throw new Error("Invalid data");
    return {} as Settings;
  }
  return {
    id: nbVal(data.id),
    defaultReferenceId: nbValOrUndef(
      "default_reference_id" in data ? data?.default_reference_id : undefined
    ),
    defaultReference: formatToGeneratedReference(
      "default_reference" in data ? data.default_reference : undefined
    ),
    defaultTableId: nbValOrUndef(
      "default_table_id" in data ? data?.default_table_id : undefined
    ),
    references:
      "references" in data
        ? formateToSettingsReference(data.references)
        : undefined,
  };
}

function formateToSettingsReference(data: unknown): SettingsReference {
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    // TODO: throw new Error("Invalid data");
    return new Map();
  }
  const result: SettingsReference = new Map();
  for (const [key, val] of Object.entries(data)) {
    result.set(key, {
      kpis: listValOrUndef("kpis" in val ? val.kpis : undefined, formatKpi),
      referenceId: nbValOrUndef(
        "reference_id" in val ? val.reference_id : undefined
      ),
    });
  }
  return result;
}

function formatKpi(data: unknown): Kpi {
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    throw new Error("Invalid KPI data");
  }
  return {
    name: strValOrUndef("name" in data ? data.name : undefined),
    property: strValOrUndef("porperty" in data ? data.porperty : undefined),
    value: strValOrUndef("value" in data ? data.value : undefined),
  };
}
